import React from 'react';
import { Button } from '@/components/ui/button';
import Marquee from '@/components/Marquee';
import LogoSlider from "@/components/LogoSlider";
import { Separator } from '@radix-ui/react-select';
import { Link } from "react-router-dom";
import { Gift, LineSquiggle } from "lucide-react";

function Home() {
  return (
    <>
    <div
      className='text-center max-w-prose mx-auto my-12'>

      <p className='font-sans tracking-wider p-4'>PALAIS ANTOIA • LAUNCHING 2027</p>
      <p className="text-3xl font-kalice px-4 "><span className='italic'>Antoia</span> is a design atelier transforming personal stories into unique fashion, jewellery, and interior objects.
      With data as our material, we create hand-made pieces that exist only once — shaped by you. Each piece becomes an heirloom, carrying your story forward through time.
      </p>
    </div>







<Separator className='border border-white/20'></Separator>

<div
      className='text-center max-w-prose mx-auto my-12'> {/* Add mx-auto to center the div */}
      {/* <h1 className="text-2xl font-bold mb-6 font-custom">Home of data couture</h1> */}
      <p className="text-3xl font-kalice px-4 "> Antoia is only accessible by invitation. Request access or <span className='italic'>make a booking</span>.
      </p>
      <div
    className='flex justify-between my-8 space-x-2 px-6'
    > <Link to="/requestaccess" className="w-full">
    <Button
      className="w-[100%] dark bg-black hover:bg-[#2c2c2c] rounded-none"
      variant="secondary"
    >
      Request access
    </Button>
  </Link>
    {/* <Button className="w-[100%] dark bg-transparent border-black hover:border-black border-2 hover:bg-black hover:text-[#ddd]" variant="outline">Request access →</Button> */}

<Link to="/signin" className="w-full">
<Button
  variant="outline"
  className="group w-[100%] bg-transparent border-black hover:border-[#2c2c2c] border-2 hover:bg-[#ddd] text-black hover:text-[#2c2c2c] rounded-none"
> Sign in
    <span className="inline-block ml-2 transition-transform duration-300 group-hover:translate-x-3">
      →
    </span>
</Button>
</Link>

    </div>
    </div>


      {/* logo's van clients çhier, animatie */}

{/*       <div
      className='text-center max-w-prose mx-auto my-12'>
      <h1 className="text-xl font-kalice">As seen on...</h1>
    </div> */}

{/* Logo slide animation */}
{/* <Marquee/> */}
{/* <LogoSlider /> */}
    </>
  );
}

export default Home;